import React, { useState, useEffect, useRef } from "react";
import { connect, shallowEqual, useSelector } from "react-redux";
import * as advertRedux from "modules/Advert/_redux/advertRedux";
import * as initialRedux from "modules/Initial/_redux/initialRedux";
import * as advertEndpoint from "modules/Advert/_redux/advertEndpoint";
import AdvertCard from "./AdvertCard";
import {
  NumberParam,
  StringParam,
  useQueryParams,
  withDefault,
} from "use-query-params";
import { Backdrop, CircularProgress } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

function AdvertSection(props) {
  const myRef = useRef(null);
  const classes = useStyles();
  const [loading, setLoading] = useState(false);

  const { adverts } = useSelector(
    (state) => ({
      adverts: state.advert.adverts,
    }),
    shallowEqual
  );

  const [width, setWidth] = useState(window.innerWidth);
  // const [limitParams, setLimitParams] = useQueryParam("limit", NumberParam);
  const [query, setQuery] = useQueryParams({
    page: withDefault(NumberParam, 1),
    limit: withDefault(NumberParam, 12),
    sortBy: withDefault(StringParam, "desc"),
    kind: withDefault(StringParam, "all"),
  });

  const setKind = (kind) => setQuery({ kind, page: 1 });

  function nextQuery(data) {
    myRef.current.scrollIntoView();
    setQuery((querys) => ({
      page: querys.page + 1,
    }));
  }
  function backQuery(data) {
    myRef.current.scrollIntoView();
    setQuery((querys) => ({
      page: querys.page - 1,
    }));
  }

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    setLoading(true);
    props.openPace();

    advertEndpoint
      .getAdvertsWithPaginate(
        query.page,
        query.limit,
        query.sortBy,
        query.kind === "all" ? undefined : query.kind
      )
      .then((res) => res.data)
      .then((adverts) => {
        props.setAdverts(adverts);
        setLoading(false);
        props.closePace();
      });
  }, [query.limit, query.page, query.sortBy, query.kind]);

  return (
    <div className="section-full bg-white content-inner-2 section-full-2 pb-2">
      <div className="container">
        <div className="d-flex job-title-bx section-head mt-1">
          <div className="col-md-12 p-0" ref={myRef}>
            <div className="mr-auto">
              <h2 className="m-b5">En Güncel İlanlar</h2>
              <h6 className="fw4 m-b0">İnteraktif ilan listesi</h6>
            </div>
            <div className="d-flex mt-3" style={{ gap: 8, flexWrap: "wrap" }}>
              {[
                { id: "all", label: "Tümü", color: "#0F1B17" },
                { id: "buyer", label: "Alınan", color: "#F08A3E" },
                { id: "seller", label: "Satılan", color: "#1EC28B" },
              ].map((tab) => {
                const active = query.kind === tab.id;
                return (
                  <button
                    key={tab.id}
                    onClick={() => setKind(tab.id)}
                    style={{
                      padding: "6px 16px",
                      borderRadius: 999,
                      border: `1.5px solid ${tab.color}`,
                      background: active ? tab.color : "transparent",
                      color: active ? "#fff" : tab.color,
                      fontWeight: 700,
                      fontSize: 13,
                      cursor: "pointer",
                      outline: "none",
                    }}
                  >
                    {tab.label}
                  </button>
                );
              })}
            </div>
          </div>
          {/*  <div className="align-self-end">
            <Link to={"/browse-job"} className="site-button button-sm">
              Kategoriler <i className="fa fa-long-arrow-right"></i>
            </Link>
          </div>*/}
        </div>

        <div className="row post-job-bx browse-job">
          {adverts.results?.map((item, index) => (
            <AdvertCard advert={item} key={index} />
          ))}
        </div>
        <div className="m-t30 mb-4">
          <div className="d-flex col justify-content-between">
            <div>
              {adverts.page !== 1 && (
                <button
                  disabled={query.page === 1}
                  className="site-button button-sm mr-auto"
                  onClick={() => backQuery()}
                >
                  <i className="ti-arrow-left" /> Geri
                </button>
              )}
            </div>
            <div>
              {adverts.page !== adverts.totalPages && (
                <button
                  className="site-button button-sm"
                  onClick={() => nextQuery()}
                >
                  İleri <i className="ti-arrow-right" />
                </button>
              )}
            </div>
          </div>
        </div>

        {/*<div className="d-flex justify-content-between flex-wrap">*/}
        {/*  <EditorCard />*/}
        {/*  <EditorCard />*/}
        {/*  <EditorCard />*/}
        {/*</div>*/}
      </div>
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
}));
export default connect(null, {
  ...advertRedux.actions,
  ...initialRedux.actions,
})(AdvertSection);
